module.exports = [
    '$analytics', 
    '$uibModal', 
    annotationsModal
];

function annotationsModal(
    $analytics, 
    $uibModal
) {

    var modal = {
        fileUrl: null,
        modalTitle: null,
        show: showModal
    };

    pdfViewerModalController.$inject = [
        '$sce',
        '$uibModalInstance', 
        'fileUrl',
        'modalTitle'
    ];

    function pdfViewerModalController(
        $sce,
        $uibModalInstance, 
        fileUrl,
        modalTitle
    ) {
        
        var vm = {
            $onInit: attached,
            cancel: cancel,
            fileUrl: $sce.trustAsResourceUrl(fileUrl),
            modalTitle: modalTitle
        };

        function attached() {}


        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        return vm;
    }

    function showModal(fileUrl, modalTitle) {
        $analytics.eventTrack('open-modal-schedule-b-chapter-notes', { category: 'legal-notes' });
        return $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: pdfViewerModalController,
            controllerAs: 'ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                fileUrl: function() {
                    return fileUrl;
                },
                modalTitle: function() {
                    return modalTitle;
                }
            },
            size: 'lg',
            templateUrl: 'texts/modals/pdf-viewer.html',
            windowClass: 'modal-wide'
        }).result.catch(function (res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                throw res;
            }
        });
    }

    return modal;
}
